<div class="attachment-section">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center flex-grow-1">
            <!-- Badge de status (na frente do título) -->
            <h2 [style.margin-right]="badgeStatus ? '12px' : '0'">{{label}}</h2>
        </div>

        <div class="d-flex align-items-center">
            <span *ngIf="badgeStatus" class="attachments-status-badge"
                [class.complete]="badgeStatus.status === 'complete' || badgeStatus.status === 'no-required'"
                [class.incomplete]="badgeStatus.status === 'incomplete'">
                <svg-icon src="assets/images/icon-check-filled.svg"
                    *ngIf="badgeStatus.status === 'complete' || badgeStatus.status === 'no-required'"></svg-icon>
                <svg-icon src="assets/images/icon-warning.svg"
                    *ngIf="badgeStatus.status === 'incomplete'"></svg-icon>
                <span
                    *ngIf="badgeStatus.status === 'incomplete' && badgeStatus.missing > 0">
                    {{badgeStatus.missing}} {{badgeStatus.missing === 1 ?
                    'documento obrigatório pendente' : 'documentos obrigatórios
                    pendentes'}}
                </span>
                <span *ngIf="badgeStatus.status === 'complete'">
                    Documentos obrigatórios enviados
                </span>
                <span *ngIf="badgeStatus.status === 'no-required'">
                    Nenhum documento obrigatório a ser enviado
                </span>
            </span>
            <button type="button" class="collapse-button"
                (click)="isCollapsed = ! isCollapsed"
                [attr.aria-expanded]="!isCollapsed"
                aria-controls="collapseExample">
                <svg-icon
                    [src]="isCollapsed ? 'assets/images/carbon-chevron-down.svg' : 'assets/images/carbon-chevron-up.svg'"></svg-icon>
            </button>
        </div>
    </div>

    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <app-spacer [top]="30"></app-spacer>
        <ng-content>
        </ng-content>
    </div>
</div>